import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { formatBlogDate } from '../../utils/blogUtils';
import { useHyphenate } from '../../hooks/useHyphenate';
import './BlogCard.css';

const BlogCard = ({ post, featured = false }) => {
  const { i18n } = useTranslation();
  const hyphenate = useHyphenate();

  return (
    <NavLink to={`/blog/${post._id}`} className={`blog-card${featured ? ' blog-card--featured' : ''}`}>
      <div className="blog-card-media">
        {post.image
          ? <img src={post.image} alt="" loading={featured ? 'eager' : 'lazy'} />
          : <span className="material-symbols-outlined blog-card-placeholder">article</span>}
      </div>
      <div className="blog-card-body">
        <time className="blog-card-date" dateTime={post.publishedAt}>
          {formatBlogDate(post.publishedAt, i18n.language)}
        </time>
        <h2 className="blog-card-title">
          <span>{hyphenate(post.title)}</span>
          <span className="material-symbols-outlined blog-card-arrow" aria-hidden="true">arrow_outward</span>
        </h2>
        {post.excerpt && <p className="blog-card-excerpt">{hyphenate(post.excerpt)}</p>}
      </div>
    </NavLink>
  );
};

export default BlogCard;
